import { Link } from 'react-router-dom';
import { BookOpen, ExternalLink } from 'lucide-react';
import type { NavigatorResource } from './navigator-results.types';

type NavigatorKeyResourcesProps = {
  title: string;
  resources: NavigatorResource[];
};

export const NavigatorKeyResources = ({ title, resources }: NavigatorKeyResourcesProps) => {
  if (resources.length === 0) return null;

  return (
    <aside className="rounded-2xl border border-border-subtle bg-card-base p-5">
      <h3 className="mb-3 flex items-center gap-2 font-termina text-base font-medium text-text-primary">
        <BookOpen className="h-4 w-4 text-sage" aria-hidden />
        {title}
      </h3>
      <ul className="space-y-2">
        {resources.map((resource) => (
          <li key={resource.id}>
            <Link
              to={resource.href}
              className="group flex items-start justify-between gap-2 rounded-lg border border-border-subtle px-3 py-2 transition-colors duration-150 ease-out hover:border-sage hover:bg-sage-bg"
            >
              <span className="min-w-0">
                <span className="block text-sm font-medium text-text-primary group-hover:text-sage">
                  {resource.title}
                </span>
                {resource.type && (
                  <span className="text-xs text-text-tertiary">{resource.type}</span>
                )}
              </span>
              <ExternalLink
                className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-text-tertiary group-hover:text-sage"
                aria-hidden
              />
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
};
